import { Component } from "react";

// Catches render-time/DOM errors (e.g. a browser extension mutating the page
// under React) so the user gets a recovery screen instead of a blank page.
class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("ErrorBoundary caught:", error);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="flex flex-col items-center justify-center min-h-screen text-center px-6">
        <h1 className="text-[22px] text-[#5B2E4F] mb-2">
          Something went wrong
        </h1>
        <p className="text-[14px] mb-6">
          Please reload the page. If it keeps happening, try disabling browser
          extensions.
        </p>
        <button
          className="px-6 py-3 rounded-lg bg-[#5B2E4F] text-white"
          onClick={() => window.location.reload()}
        >
          Reload
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
